'use client';

import './Contents.scss';

import { cn } from '@core/utils';
import { EditorContent } from '@tiptap/react';
import { useContext } from 'react';

import { CustomEditorContext } from '.';

export interface CustomEditorContentsProps {
  className?: string;
}

export const Contents = ({ className }: CustomEditorContentsProps) => {
  const { editor } = useContext(CustomEditorContext);

  return (
    <EditorContent
      className={cn(
        'editor-container',
        'flex flex-col overflow-auto p-16 text-left text-Gray-900',
        className,
      )}
      editor={editor as Parameters<typeof EditorContent>[number]['editor']}
    />
  );
};
